


export const FIELD_TYPE = {
    FREE_TEXT: 'FREE_TEXT',
    SEARCHABLE_DROPDOWN: 'SEARCHABLE_DROPDOWN',
    DROPDOWN: 'DROPDOWN'
}

export const MASS_UPDATE_OPTIONS = [
    {
        id: 1,
        text: 'Add to all items - Selected invoice(s)',
        text_nl: 'Add to all items - Selected invoice(s)',
        value: '1'
    },
    {
        id: 2,
        text: 'Add to all items - All invoices',
        text_nl: 'Add to all items - All invoices',
        value: '2'
    },
    {
        id: 3,
        text: 'Add to specific line items',
        text_nl: 'Add to specific line items',
        value: '3'
    }
]

export const FIELD_NAMES = [

    {
        key: 'procedure',
        text: 'PROCEDURE',
        text_nl: 'PROCEDURE',
        value: '1',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'AGS'
    },
    {
        key: 'origin',
        text: 'ORIGIN',
        text_nl: 'ORIGIN',
        value: '2',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'AGS'
    },
    {
        key: 'pkgType',
        text: 'PKG TYPE',
        text_nl: 'PKG TYPE',
        value: '3',
        fieldType: FIELD_TYPE.SEARCHABLE_DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'AGS'
    },
    {
        key: 'shippingMark',
        text: 'SHIPPING MARK',
        text_nl: 'SHIPPING MARK',
        value: '4',
        fieldType: FIELD_TYPE.FREE_TEXT,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'AGS'
    },
    {
        key: 'undg',
        text: 'UNDG',
        text_nl: 'UNDG',
        value: '5',
        fieldType: FIELD_TYPE.SEARCHABLE_DROPDOWN,
        status: 'EXPORT',
        shipmentStatus: 'AGS'
    },
    {
        key: 'addEU',
        text: 'ADD EU',
        text_nl: 'ADD EU',
        value: '6',
        fieldType: FIELD_TYPE.SEARCHABLE_DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: 'addNL',
        text: 'ADD NL',
        text_nl: 'ADD NL',
        value: '7',
        fieldType: FIELD_TYPE.SEARCHABLE_DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: '8',
        text: 'PREFERENCE',
        text_nl: 'PREFERENCE',
        value: '8',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },

    {
        key: 'addProcedure',
        text: 'ADD_PROCEDURE',
        text_nl: 'ADD_PROCEDURE',
        value: '9',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'NONE'
    },
    {
        key: '10',
        text: 'PREF. ORIGIN',
        text_nl: 'PREF. ORIGIN',
        value: '10',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: '11',
        text: 'TRANSACTION TYPE',
        text_nl: 'TRANSACTION TYPE',
        value: '11',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: 'pkgQty',
        text: '# PACKAGES',
        text_nl: '# PACKAGES',
        value: '12',
        fieldType: FIELD_TYPE.FREE_TEXT,
        status: 'IMPORT/EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: '13',
        text: 'QUOTA',
        text_nl: 'QUOTA',
        value: '13',
        fieldType: FIELD_TYPE.FREE_TEXT,
        status: 'IMPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: 14,
        text: 'PAYMENT METHOD',
        text_nl: 'PAYMENT METHOD',
        value: '14',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'EXPORT',
        shipmentStatus: 'DMS'
    },
    {
        key: 'mop',
        text: 'MOP',
        text_nl: 'MOP',
        value: '15',
        fieldType: FIELD_TYPE.DROPDOWN,
        status: 'IMPORT',
        shipmentStatus: 'DMS'
    }
]